(function ($, window, document) {
    'use strict';
    window.yu = {};
    yu.time;
    yu.timeout = false;
    yu.timeoutspan = 200;
    yu.lastScrollTop = 0;

    $(document).ready(function () {
        yu.window.init();
        yu.layout.imgoverflow();
        yu.input.initQuantity();
      if ($('#nav-footer-container').length){
        yu.nav.initNavFooter();
      }
    });

    yu.cart = {
        cartCreated: function (state) {
            console.log('yu.cart.created called');
            var _lang = $('[data-shop-language]').attr('data-shop-language');
            console.log(_lang);
            var _labFrozen = _lang == 'ja' ? '冷凍食品' : 'Frozen';
            var _labAlcohol = _lang == 'ja' ? 'アルコール飲料' : 'Alcoholic drink';

            // Clear badge content
            $('[data-cart-item-key] > td > div > .cart-details > .cart-badge').html('');
            $(state.items).each(function () {
                var itm = this;
                $.ajax({
                    type: 'GET',
                    url: '/products/' + itm.handle + '?view=metafields-json',
                    success: function (response) {
                        //jsonresponse = JSON.parse(response);
                        //console.log('response', jsonresponse);
                        //console.log(response);
                        const metafields = JSON.parse(response);
                        console.log(metafields);

                        if (metafields.frozen != null) {
                            console.log('Frozen product key:' + itm.key);
                            var _lab = $('<p>').addClass('badge-frozen').append($('<span>').text(_labFrozen));

                            $('[data-cart-item-key="' + itm.key + '"] > td > div > .cart-details > .cart-badge').append(_lab);

                        }
                        if (metafields.alcohol != null) {
                            var _lab = $('<p>').addClass('badge-alcohol').append($('<span>').text(_labAlcohol));
                            $('[data-cart-item-key="' + itm.key + '"] > td > div > .cart-details > .cart-badge').append(_lab);
                        }

                    },
                    error: function (status) {
                        console.warn('ERROR', status);
                    }
                });
            });
            //console.log(state.total_price);
        }
    };

    yu.window = {
        lastScrollTop:0,
        idleTime: 0,
        init: function () {
/*
            let screenWidth = $(window).width();
            if (screenWidth > 749) {
                let marginHeight = $('.flow-header').outerHeight();
                $('.page-container').css('margin-top', marginHeight + 'px');
            }
            else {
                $('.page-container').css('margin-top', '0px');
            }
*/
            $(window).resize(function () {
              /*
                let screenWidth = $(window).width();
                if (screenWidth > 749) {
                    let marginHeight = $('.flow-header').outerHeight();
                    $('.page-container').css('margin-top', marginHeight + 'px');
                }
                else {
                    $('.page-container').css('margin-top', '0px');
                }
              */
                yu.layout.imgoverflow();
                yu.time = new Date();
                if (yu.timeout === false) {
                    yu.timeout = true;
                    setTimeout(yu.window.windowsResized, yu.timeoutspan);
                }
            });
            $(window).on('scroll', function () {
                let st = $(this).scrollTop();
                if (st > yu.lastScrollTop) {
                    $('body').removeClass('scroll-up').addClass('scroll-down');
                } else {
                    //$('body').removeClass('scroll-down').addClass('scroll-up');

                    $('body').removeClass('scroll-down');
                    if (yu.lastScrollTop - st > 100) {
                        $('body').addClass('scroll-up');
                    }

                }
                yu.lastScrollTop = st;
                if ($(window).scrollTop() > 100) {
                    $('body').addClass('scrolled');
                }
                else {
                    $('body').removeClass('scrolled');
                }
            });
        },
        windowsResized: function () {
            if (new Date() - yu.time < yu.timeoutspan) {
                setTimeout(yu.window.windowsResized, yu.timeoutspan);
            } else {
                yu.timeout = false;
                //yu.layout.imgoverflow();
              yu.nav.resetTranslateY();
            }
        },
    };
    yu.layout = {
        imgoverflow: function () {
            if ($('[data-image-overflow]').length) {
                var _direction = $('[data-image-overflow]').attr('data-image-overflow');
                console.log('direction: ' + _direction);
                if (_direction == 'right') {
                    var _right = $(window).width() - ($('[data-image-overflow]').offset().left + $('[data-image-overflow]').outerWidth());
                    $('[data-image-overflow="right"] .image-overflow-container').css('right', '-' + _right + 'px');
                }
                else if (_direction == 'left') {
                    var left = $(window).width() - ($('[data-image-overflow]').offset().left);
                    $('[data-image-overflow="left"].image-overflow-container').css('left', '-' + left + 'px');
                }
            }
        }
    };
    yu.input = {
        initQuantity: function () {
            if ($('.quantity-input-container')) {
                // $('button[name="minus"]').click(function () {
                //     var $input = $(this).parent().find('input');
                //     var count = parseInt($input.val()) - 1;
                //     count = count < 1 ? 1 : count;
                //     $input.val(count);
                //     $input.change();
                //     return false;
                // });
                // $('button[name="plus"]').click(function () {
                //     var $input = $(this).parent().find('input');
                //     $input.val(parseInt($input.val()) + 1);
                //     $input.change();
                //     return false;
                // });
            }
        }
    };
  yu.nav = {
    initNavFooter:function(){
      var h = $('#nav-footer').outerHeight();
      $('#nav-footer-container').css('transform', 'translateY(' + h + 'px)').removeClass('active');
      $('#btn-nav-footer').on('click', function () {
          if ($('#nav-footer-container').hasClass('active')) {
              var h = $('#nav-footer').outerHeight();
              $('#nav-footer-container').css('transform', 'translateY(' + h + 'px)').removeClass('active');
              $('#btn-nav-footer i').removeClass('fa-circle-down').addClass('fa-circle-up');
          }
          else {
             $('#nav-footer-container').css('transform', 'translateY(0)').addClass('active');
              $('#btn-nav-footer i').removeClass('fa-circle-up').addClass('fa-circle-down');
          }
      });
    },
    resetTranslateY:function(){
       if ($('#nav-footer-container').hasClass('active')) {
             $('#nav-footer-container').css('transform', 'translateY(0)');
          }
          else {
             var h = $('#nav-footer').outerHeight();
              $('#nav-footer-container').css('transform', 'translateY(' + h + 'px)');             
          }
    }
  };
}(window.jQuery, window, document));
